import React, { useEffect, useCallback, useMemo, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { clearAlerts } from '../store/alert/alertSlice';
import ClipLoader from 'react-spinners/ClipLoader';
import { deleteFocusCustomThunk, deleteFocusEvenThunk, deleteFocusMusicThunk, deleteFocusNewsletterThunk, deleteFocusProductThunk } from '../store/focuspage/focuspageThunk';
import { deleteCustomBrandSection } from '../store/addsection/addsectionThunk';

// Custom styles for more Apple-like notifications
const toastStyles = {
    success: {
        style: {
            background: 'rgba(0, 0, 0, 0.8)',
            backdropFilter: 'blur(10px)',
            color: 'white',
            borderRadius: '12px',
            padding: '12px 24px',
            fontSize: '14px',
            fontWeight: '500',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            transition: 'all 0.3s ease',
            border: '1px solid rgba(255, 255, 255, 0.1)',
        }
    },
    delete: {
        style: {
            background: 'rgba(0, 0, 0, 0.8)',
            backdropFilter: 'blur(10px)',
            color: 'white',
            borderRadius: '12px',
            padding: '12px 24px',
            fontSize: '14px',
            fontWeight: '500',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            transition: 'all 0.3s ease',
            border: '1px solid rgba(255, 255, 255, 0.1)',
        }
    },
    error: {
        style: {
            background: 'rgba(0, 0, 0, 0.8)',
            backdropFilter: 'blur(10px)',
            color: 'white',
            borderRadius: '12px',
            padding: '12px 24px',
            fontSize: '14px',
            fontWeight: '500',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            transition: 'all 0.3s ease',
            border: '1px solid rgba(255, 255, 255, 0.1)',
        }
    }
};

const Alert = () => {
    const dispatch = useDispatch();
    const alert = useSelector((state) => state.alert);

    const showErrorToast = useCallback((message) => {
        if (!message || message.includes('approve_subscription')) return;

        toast.error(message, {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            toastId: 'error-toast',
            transition: Slide,
            ...toastStyles.error
        });
    }, []);

    const showSuccessToast = useCallback((message) => {
        if (!message) return;

        toast.success(message, {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            toastId: 'success-toast',
            ...toastStyles.success
        });
    }, []);

    const showDeleteToast = useCallback((message) => {

        let { type, data } = message;
        let { token, payload } = data

        const toastId = toast(
            ({ closeToast }) => (
                <div>
                    <p>Are you sure you would like to delete your focus page?</p>
                    <div style={{ marginTop: '0.5rem', display: 'flex', gap: '0.5rem' }}>
                        <button
                            onClick={() => {
                                // onConfirm();       // do the deletion
                                if (type == 'custom') {

                                    dispatch(deleteFocusCustomThunk({
                                        token, payload
                                    }));

                                } else if (type == 'music') {

                                    dispatch(deleteFocusMusicThunk({
                                        token, payload
                                    }));

                                } else if (type == 'event') {

                                    dispatch(deleteFocusEvenThunk({
                                        token, payload
                                    }));

                                } else if (type == 'newsletter') {

                                    dispatch(deleteFocusNewsletterThunk({
                                        token, payload
                                    }));

                                } else if (type == 'product') {

                                    dispatch(deleteFocusProductThunk({
                                        token, payload
                                    }));

                                } else if (type == 'custom-brand') {

                                    // dispatch(deleteFocusProductThunk({
                                    //     token, payload
                                    // }));

                                    dispatch(deleteCustomBrandSection({ token, payload }));

                                } 
                                toast.dismiss(toastId);
                            }}
                            style={{ background: 'red', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px' }}
                        >
                            Delete
                        </button>
                        <button
                            onClick={() => toast.dismiss(toastId)}
                            style={{ background: '#ccc', border: 'none', padding: '6px 12px', borderRadius: '4px' }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            ),
            {
                position: 'top-center',
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                toastId: 'delete-toast',
                ...toastStyles.delete
            }
        );
    }, []);

    useEffect(() => {
        let timeoutId;

        if (alert?.error && !alert?.silentError) {
            showErrorToast(alert.error);
            timeoutId = setTimeout(() => {
                dispatch(clearAlerts());
            }, 3000);
        }

        if (alert?.success) {
            showSuccessToast(alert.success);
            timeoutId = setTimeout(() => {
                dispatch(clearAlerts());
            }, 3000);
        }

        if (alert?.delete) {
            showDeleteToast(alert.delete);
            timeoutId = setTimeout(() => {
                dispatch(clearAlerts());
            }, 1000);
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [alert?.error, alert?.success, alert?.delete, dispatch, showErrorToast, showDeleteToast, showSuccessToast]);

    return (
        <ToastContainer
            style={{ zIndex: 99999 }}
            className={'toast-container-dizee'}
            limit={1}
            enableMultiContainer={false}
            transition={Slide}
        />
    );
};

export default memo(Alert);
